module.exports = "../fonts/search_icon_gray.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/search_icon_gray.svg
// module id = 321
// module chunks = 0